import DiscoverIconSM from "@/components/DiscoverIconSm";
import {
  Card,
  Center,
  Container,
  Divider,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

const data = [
  { title: "Discover", link: "/" },
  { title: "What is a songcard?", link: "/info" },
  { title: "For Artists", link: "/artist-guide" },
  { title: "Blog", link: "/blog" },

  // {
  //   title: "Create a songcard",
  //   link: "https://create.songcards.io",
  //   external: true,
  // },
  { title: "Card Of The Day", link: "/cotd" },
  // { title: "Discover", link: "/" },
  {
    title: "Get App",
    link: "/get-app",
    external: false,
  },
  // {
  //   title: "Android App",
  //   link: "https://play.google.com/store/apps/details?id=com.songcards.songcards&pcampaignid=web_share&utm_source=substack&utm_medium=email",
  //   external: true,
  // },
  {
    title: "Interview w/ Soundworks",
    link: "https://soundworks.substack.com/p/inside-songcards-a-creative-take",
    external: true,
  },

  {
    title: "Collector's Club",
    link: "https://songcards.substack.com/embed",
    external: true,
  },
  // {
  //   title: "Artist FAQs",
  //   link: "https://open.substack.com/pub/unlockyoursound/p/faqs-about-songcards?r=3hpxh&utm_campaign=post&utm_medium=web&showWelcomeOnShare=true",
  //   external: true,
  // },
  // { title: "Terms", link: "/terms" },
  { title: "Account", link: "/account" },
  { title: "Discord", link: "https://discord.gg/ZqyaGf4EPc" },
  {
    title: "Support",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfelEQmiE8Yr589pqjhEDeGJXyqGwuYZ-ROTlTy_b6mw5ErqA/viewform?usp=sf_link",
    external: true,
  },
  { title: "Contact", link: "mailto:chris@songcards.io" },
];

// https://songcards.substack.com/embed

export default function LinkPage() {
  const { colorMode } = useColorMode();

  return (
    <>
      <Head>
        <title>Links | Songcards</title>
        <meta property="og:site_name" content="Songcards" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href="https://songcards.io/links" />
        <meta name="description" content="Listen. Discover. Collect." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" href="/SC Icon_A_Light.svg" />
        <link rel="icon" href="/SC Icon_A_Light.svg" />

        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/links" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Songcards" />
        <meta property="og:title" content="Links | Songcards" />
        <meta property="og:description" content="Listen. Discover. Collect." />
        <meta name="twitter:domain" content="songcards.io" />
        <meta name="twitter:site" content="@unlockyoursound" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Links | Songcards" />
        <meta name="twitter:description" content="Listen. Discover. Collect." />

        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <meta name="apple-itunes-app" content="app-id=6737206374" />
      </Head>
      <Center>
        <Image
          src={
            colorMode == "light"
              ? "Songcards_B_Black.svg"
              : "Songcards_B_White.svg"
          }
          alt={"songcards logo"}
          width={250}
          height={250}
        />
      </Center>
      <Center>
        <Text mt={5} mb={5}>
          Listen. Discover. Collect.
        </Text>
      </Center>
      <Center>
        <Divider maxW={300} mb={5} />
      </Center>
      {data.map((link, index) => (
        <Center key={index}>
          <Link href={link.link} target={link.external ? "_blank" : undefined}>
            <Card
              maxW="xs"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgColor={colorMode === "dark" ? "black" : "white"}
              variant="outline"
              borderColor={colorMode === "dark" ? "white" : "black"}
              borderStyle="dotted"
              borderRadius={20}
              height="50px"
              width="300px"
              textAlign="center"
            >
              <Text>{link.title}</Text>
            </Card>
          </Link>
          <br />
          <br />
          <br />
        </Center>
      ))}
      <DiscoverIconSM />
      <Container mb={200}>
        <></>
      </Container>
    </>
  );
}
